import { boolean, date, pgTable, text, timestamp, uuid, varchar } from "drizzle-orm/pg-core"
import { estates } from "./estate"
import { users } from "./users"

// Purpose: Defines priority levels for checklists.
export const checklistPriorities = pgTable("checklist_priority", {
  id: uuid("id").primaryKey().defaultRandom(),
  name: varchar("name", { length: 50 }).notNull().unique(),
})

// Purpose: Manages lists of tasks, often grouped for specific estate planning processes.
export const checklists = pgTable("checklist", {
  id: uuid("id").primaryKey().defaultRandom(),
  estateId: uuid("estate_id")
    .notNull()
    .references(() => estates.id, { onDelete: "cascade" }),
  checklistItemComplete: boolean("checklist_item_complete").default(false),
  checklistPriorityId: uuid("checklist_priority_id")
    .notNull()
    .references(() => checklistPriorities.id),
  title: varchar("title", { length: 255 }).notNull(),
  description: text("description"),
  dueDate: date("due_date"),
  createdAt: timestamp("created_at").defaultNow().notNull(),
  // Note: For 'ON UPDATE CURRENT_TIMESTAMP' functionality in PostgreSQL,
  // a database trigger is required. This schema sets the timestamp on creation,
  // and application logic or a trigger should handle updates.
  updatedAt: timestamp("updated_at").defaultNow().notNull(),
})

// Purpose: Represents individual actions or items within a checklist.
export const tasks = pgTable("task", {
  id: uuid("id").primaryKey().defaultRandom(),
  estateId: uuid("estate_id")
    .notNull()
    .references(() => estates.id, { onDelete: "cascade" }),
  assignedToUserId: varchar("assigned_to_user_id", { length: 255 }).references(() => users.id, {
    onDelete: "cascade",
  }),
  title: varchar("title", { length: 255 }).notNull(),
  description: text("description"),
  dueDate: date("due_date"),
  taskComplete: boolean("task_complete").default(false),
  completionDate: date("completion_date"),
  createdAt: timestamp("created_at").defaultNow().notNull(),
  // Note: For 'ON UPDATE CURRENT_TIMESTAMP' functionality in PostgreSQL,
  // a database trigger is required. This schema sets the timestamp on creation,
  // and application logic or a trigger should handle updates.
  updatedAt: timestamp("updated_at").defaultNow().notNull(),
})
